import Home from "./components/home";
import "./index.css";

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
